import { render, staticRenderFns } from "./dingLogin.vue?vue&type=template&id=29447e10&"
import script from "./dingLogin.vue?vue&type=script&lang=js&"
export * from "./dingLogin.vue?vue&type=script&lang=js&"
import style0 from "./dingLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports